/**
 * @fileoverview Email Confirmed Success Modal
 * @description Modal shown after user clicks email confirmation link
 */

import { useTranslation } from 'react-i18next'
import { Modal, Text, Button, Stack, Center } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'

interface EmailConfirmedModalProps {
  opened: boolean
  onClose: () => void
}

/**
 * Modal shown after successful email confirmation
 */
export const EmailConfirmedModal = ({
  opened,
  onClose,
}: EmailConfirmedModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('email_confirmation.success_title')}
      centered
      closeOnClickOutside={true}
      closeOnEscape={true}
      withCloseButton={true}
      size="md"
    >
      <Stack spacing="lg">
        <Center>
          <IconCircleCheck size={64} color="teal" stroke={1.5} />
        </Center>

        <Text align="center" size="md">
          {t('email_confirmation.success_description')}
        </Text>

        <Text align="center" size="sm" color="dimmed">
          {t('email_confirmation.success_ready')}
        </Text>

        <Button
          fullWidth
          size="lg"
          color="teal"
          onClick={onClose}
        >
          {t('email_confirmation.continue')}
        </Button>
      </Stack>
    </Modal>
  )
}
